/* ============================================================
   proart-product.js
   Pro Art Cartridge — Page produit (variantes, galerie, ATC)
   ============================================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' $';
  }

  function init() {
    var section = document.querySelector('[data-pprod]');
    if (!section) return;

    var jsonEl = section.querySelector('[data-pprod-json]');
    var productData = null;
    try {
      productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (e) {
      console.error('proart-product: invalid product JSON', e);
    }

    /* Labels come from the section settings, with the previous strings as fallback. */
    var labels = {
      atc: section.getAttribute('data-label-atc') || 'AJOUTER AU PANIER',
      soldout: section.getAttribute('data-label-soldout') || 'ÉPUISÉ',
      unavailable: section.getAttribute('data-label-unavailable') || 'INDISPONIBLE',
      added: section.getAttribute('data-label-added') || '✓ AJOUTÉ'
    };

    var form = document.getElementById('pprod-form');
    var variantInput = section.querySelector('[data-pprod-variant-id]');
    var priceEl = section.querySelector('[data-pprod-price]');
    var compareEl = section.querySelector('[data-pprod-compare]');
    var promoEl = section.querySelector('[data-pprod-promo]');
    var atcBtn = section.querySelector('[data-pprod-atc]');
    var errorEl = section.querySelector('[data-pprod-error]');
    var mainImg = section.querySelector('[data-pprod-main-img]');
    var qtyInput = section.querySelector('[data-pprod-qty-input]');
    var stickyBar = section.querySelector('[data-pprod-sticky]');
    var stickyAtc = section.querySelector('[data-pprod-sticky-atc]');
    var stickyPrice = section.querySelector('[data-pprod-sticky-price]');

    /* ── Variantes ── */

    function selectedOptions() {
      var values = [];
      section.querySelectorAll('[data-pprod-option]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(values) {
      if (!productData || !values.length) return null;
      return productData.variants.find(function (v) {
        return values.every(function (val, i) {
          return v.options[i] === val;
        });
      }) || null;
    }

    function setAtcState(btn, available, exists) {
      if (!btn) return;
      var label = btn.querySelector('span') || btn;
      if (!exists) {
        btn.disabled = true;
        label.textContent = labels.unavailable;
      } else if (!available) {
        btn.disabled = true;
        label.textContent = labels.soldout;
      } else {
        btn.disabled = false;
        label.textContent = labels.atc;
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        setAtcState(atcBtn, false, false);
        setAtcState(stickyAtc, false, false);
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (promoEl) promoEl.hidden = !onSale;

      setAtcState(atcBtn, variant.available, true);
      setAtcState(stickyAtc, variant.available, true);

      if (variant.featured_image && variant.featured_image.src && mainImg) {
        swapMainImage(variant.featured_image.src);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    section.querySelectorAll('[data-pprod-option] input').forEach(function (input) {
      input.addEventListener('change', function () {
        hideError();
        applyVariant(findVariant(selectedOptions()));
      });
    });

    /* ── Galerie ── */

    function swapMainImage(src) {
      if (!mainImg || mainImg.src === src) return;
      mainImg.classList.add('is-fading');
      var next = new Image();
      next.onload = function () {
        /* Le srcset initial (responsive, pour le LCP) décrit la PREMIÈRE image.
           Le laisser en place ferait gagner ses candidats sur le nouveau src :
           la vignette cliquée ne changerait rien à l'écran. */
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.classList.remove('is-fading');
      };
      next.src = src;
    }

    section.querySelectorAll('[data-pprod-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.querySelectorAll('[data-pprod-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        swapMainImage(thumb.dataset.fullSrc);
      });
    });

    /* ── Quantité ── */

    function clampQty() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }

    var qtyMinus = section.querySelector('[data-pprod-qty-minus]');
    var qtyPlus = section.querySelector('[data-pprod-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, clampQty() - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyInput.value = clampQty() + 1;
    });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* ── ATC ── */

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    function submitAtc() {
      if (!window.proartCart || !window.proartCart.add) return true; // fall back to native POST
      hideError();

      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return false;

      var qty = qtyInput ? clampQty() : 1;
      var label = atcBtn.querySelector('span') || atcBtn;
      var origText = label.textContent;
      atcBtn.disabled = true;
      label.textContent = '...';

      window.proartCart.add(variantId, qty)
        .then(function () {
          label.textContent = labels.added;
          window.proartCart.open();
          setTimeout(function () {
            label.textContent = origText;
            atcBtn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          showError(err.message || 'Erreur lors de l\'ajout au panier.');
          label.textContent = origText;
          atcBtn.disabled = false;
        });
      return false;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (submitAtc() === false) e.preventDefault();
      });
    }

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        submitAtc();
      });
    }

    /* ── Sticky mobile bar ── */

    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      }, { threshold: 0 });
      obs.observe(atcBtn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
